/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { DelServiceProviderDtoModel } from './del-service-provider-dto.model';
import { VendorTagDtoModel } from './vendor-tag-dto.model';

export class VendorDtoModel {
  uuid: string | undefined = undefined;
  serviceProvider: DelServiceProviderDtoModel | undefined = undefined;
  tags: VendorTagDtoModel[] | undefined = undefined;
  paymentTimeLimit: string | undefined = undefined;
  owner: string | null = null;
}
